import { ObservableObject } from './patch';

export const observableStoreOp = new ObservableObject();
